<template>
  <div class="instructors-slider">
    <div class="container">
      <Slider
        v-if="instructors.length"
        :class="options.background"
        :class-name="options.className"
      >
        <h2 slot="heading" class="h3 col-8">
          {{ options.title }}
        </h2>
        <p v-if="options.subtitle" slot="subtitle" class="col-7">
          {{ options.subtitle }}
        </p>
        <div
          v-for="(instructor, i) in instructors"
          :key="i"
          slot="slide"
          class="col col-3 sm-6"
        >
          <div
            :key="i"
            class="single-member"
          >
            <component
              :is="instructorslinks ? 'nuxt-link' : 'div'"
              :to="`/instructors/${instructor.userSlug}/`"
              class="front-cover"
              :style="{ backgroundImage: `url(${$config.imagesUrl}/team/${instructor.image})` }"
            >
              <div class="member-desc">
                <h3 class="h4">
                  {{ instructor.name }}
                </h3>
                <div class="desc">
                  {{ instructor.memberSignature }}
                </div>
                <Component
                  :is="icon(instructor.memberSignatureCompany)"
                  v-if="instructor.memberSignatureCompany"
                />
              </div>
            </component>
          </div>
        </div>
      </Slider>
    </div>
  </div>
</template>

<script>
import Slider from '@itbpbg/lms-components/src/components/Slider';

export default {
  components: {
    Slider,
  },
  props: {
    instructors: { type: Array, default: () => [], required: true },
    options: { type: Object, default: () => {}, required: true },
    instructorslinks: { type: Boolean },
  },
  methods: {
    icon(img) {
      return img ? require(`../../assets/svg/companies/logo-${img.slug}.svg?vue-component`) : '';
    },
  },
};
</script>

<style lang="scss" scoped>
.single-member {
  .front-cover {
    display: block;
    background-color: #C4C4C4;
    border-radius: 10px;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    image-rendering: -webkit-optimize-contrast;
    position: relative;
    padding-top: 130%;
    overflow: hidden;

    .member-desc {
      bottom: 0;
      position: absolute;
      padding: var(--spacing-24) var(--spacing-36);
      text-align: center;
      width: 100%;

      .h4 {
        color: var(--main-light);
        margin-bottom: var(--spacing-8);
      }

      .desc {
        color: rgba(255, 255, 255, 0.74);
        line-height: 110%;
        font-size: 18px;
        margin-bottom: var(--spacing-8);
      }
    }
  }
}
</style>
